<ion-header class="ion-no-border ion-header-modal-desktop">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button data-cy="close-modal-button" (click)="closeModal()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label data-cy="modal-title-text">
      {{ title }}
      <div
        class="page-name"
        data-cy="modal-subtitle-text"
        [innerHTML]="subtitle"
      ></div>
    </ion-label>
    <div class="horizontal-divider"></div>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-content-modal-desktop">
  <ion-grid>
    <section>
      <ion-row>
        <ion-col>
          <p class="main-text" data-cy="modal-content-text">
            {{ text }}
          </p>
        </ion-col>
      </ion-row>
    </section>
  </ion-grid>
</ion-content>
